<template>
    <section class="content-loading-block">
        <div class="animated-background" :style="'height:' + defaultHeight"></div>
    </section>
</template>

<script>
import Size from "@/mixins/Size/Size";

import "./ContentLoadingBlock.scss";

export default {
    name: "ContentLoadingBlock",
    props: {
        height: {
            type: String,
            default: "auto"
        }
    },
    mixins: [Size],
    computed: {
        defaultHeight() {
            if (this.height !== "auto") {
                return this.height;
            } else {
                if (this.size === "sm") {
                    return "31px";
                } else if (this.size === "") {
                    return "38px";
                } else {
                    return "40px";
                }
            }
        }
    }
};
</script>